import { render } from "./PanelAdmin.vue?vue&type=template&id=58549f1e"
import script from "./PanelAdmin.vue?vue&type=script&lang=js"
export * from "./PanelAdmin.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__